import React from 'react';

const NoMatch = () => {
    return (
        <div>
            <h1>404 Not found!</h1>
        </div>
    );
};

export default NoMatch;